module.exports = __webpack_public_path__ + "static/media/wecre8.b0c493e7.png";